export const FEATURE_NAME = '@zerops/zerops/feature/http-routing-add-dialog';

export const EXISTING_DIALOG_KEY = `${FEATURE_NAME}_existing`;
